<template>
  <th @click.prevent="sortBy(sortField)">
    <slot></slot>
  </th>
</template>
<script>
export default {
  name: "th-sort-field",
  props: {
    sortField: {
      required: true,
      type: String
    },
    dataRow: {
      required: true
    }
  },
  data() {
    return {
      tableLines: [],
      sort: []
    };
  },
  methods: {
    sortBy(sortField) {
      if (sortField != "no-sort") {
        this.sort[sortField] = this.sort[sortField] == "desc" ? "asc" : "desc";
        this.$emit('update:dataRow', _.orderBy(this.dataRow, sortField, this.sort[sortField]))
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/UIComponents/Tables/ThSortField.vue